(() => {
  const initialize = (root) => {
    const form = root.querySelector('[data-knowledge-search]');
    if (!form) return;
    const input = form.querySelector('[data-knowledge-query]');
    const clear = form.querySelector('[data-knowledge-clear]');
    const filters = [...root.querySelectorAll('[data-category]')];
    const cards = [...root.querySelectorAll('[data-knowledge-article]')];
    const grid = root.querySelector('[data-knowledge-results]');
    const status = root.querySelector('[data-knowledge-status]');
    const none = root.querySelector('[data-knowledge-none]');
    const failure = root.querySelector('[data-knowledge-error]');
    const reset = root.querySelector('[data-knowledge-reset]');
    const retry = root.querySelector('[data-knowledge-retry]');
    const pagination = root.querySelector('[data-knowledge-pagination]');
    const pageList = root.querySelector('[data-page-list]');
    const previous = root.querySelector('[data-page-previous]');
    const next = root.querySelector('[data-page-next]');
    const pageSize = Math.max(1, Number(root.dataset.pageSize) || 8);
    let currentPage = 1;
    let category = '';
    let requestedFocus = false;

    let locale;
    try { locale = Intl.getCanonicalLocales(root.lang || document.documentElement.lang)[0]; } catch (_) { locale = undefined; }
    const normalize = (value) => {
      const text = String(value || '').normalize('NFKC').replace(/\s+/g, ' ').trim();
      return locale ? text.toLocaleLowerCase(locale) : text.toLowerCase();
    };
    const params = new URLSearchParams(window.location.search);
    input.value = (params.get('q') || '').slice(0, 160);
    category = filters.some((button) => button.dataset.category === params.get('category')) ? (params.get('category') || '') : '';
    currentPage = Math.max(1, Number.parseInt(params.get('page') || '1', 10) || 1);

    const updateUrl = (mode = 'push') => {
      const nextParams = new URLSearchParams(window.location.search);
      const query = input.value.trim();
      query ? nextParams.set('q', query) : nextParams.delete('q');
      category ? nextParams.set('category', category) : nextParams.delete('category');
      currentPage > 1 ? nextParams.set('page', String(currentPage)) : nextParams.delete('page');
      const queryString = nextParams.toString();
      const url = `${window.location.pathname}${queryString ? `?${queryString}` : ''}${window.location.hash}`;
      if (`${window.location.pathname}${window.location.search}${window.location.hash}` === url) return;
      window.history[mode === 'replace' ? 'replaceState' : 'pushState']({ knowledgeLibrary: true }, '', url);
    };
    const renderPages = (pageCount) => {
      pageList.replaceChildren();
      for (let page = 1; page <= pageCount; page += 1) {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = String(page);
        button.dataset.page = String(page);
        button.setAttribute('aria-label', `${pagination.getAttribute('aria-label')} ${page}`);
        if (page === currentPage) button.setAttribute('aria-current', 'page');
        pageList.append(button);
      }
      pagination.hidden = pageCount <= 1;
      previous.disabled = currentPage === 1;
      next.disabled = currentPage === pageCount;
    };
    const render = ({ updateHistory = true } = {}) => {
      const query = normalize(input.value);
      const matches = cards.filter((card) => (!query || normalize(card.dataset.search).includes(query)) && (!category || card.dataset.category === category));
      const pageCount = Math.max(1, Math.ceil(matches.length / pageSize));
      currentPage = Math.min(currentPage, pageCount);
      const start = (currentPage - 1) * pageSize;
      cards.forEach((card) => { card.hidden = true; });
      matches.slice(start, start + pageSize).forEach((card) => { card.hidden = false; });
      filters.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.category === category)));
      clear.hidden = input.value.length === 0;
      none.hidden = matches.length !== 0;
      failure.hidden = true;
      grid.hidden = matches.length === 0;
      grid.setAttribute('aria-busy', 'false');
      status.textContent = `${matches.length} ${matches.length === 1 ? status.dataset.singular : status.dataset.plural}`;
      renderPages(pageCount);
      if (updateHistory) updateUrl('push');
      if (requestedFocus) {
        requestedFocus = false;
        const firstLink = grid.querySelector('.knowledge-card:not([hidden]) h2 a');
        (firstLink || input).focus({ preventScroll: true });
      }
    };
    const resetAll = () => {
      input.value = '';
      category = '';
      currentPage = 1;
      requestedFocus = true;
      render();
    };

    let debounce;
    form.addEventListener('input', () => {
      window.clearTimeout(debounce);
      debounce = window.setTimeout(() => { currentPage = 1; render(); }, 160);
    });
    form.addEventListener('reset', () => window.setTimeout(resetAll));
    form.addEventListener('submit', (event) => { event.preventDefault(); currentPage = 1; requestedFocus = true; render(); });
    filters.forEach((button) => button.addEventListener('click', () => { category = button.dataset.category || ''; currentPage = 1; requestedFocus = true; render(); }));
    reset.addEventListener('click', resetAll);
    retry.addEventListener('click', () => window.location.reload());
    pagination.addEventListener('click', (event) => {
      const button = event.target.closest('button');
      if (!button || button.disabled) return;
      if (button === previous) currentPage -= 1;
      else if (button === next) currentPage += 1;
      else if (button.dataset.page) currentPage = Number(button.dataset.page);
      requestedFocus = true;
      render();
      root.querySelector('.knowledge__browse').scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    });
    window.addEventListener('popstate', () => {
      const nextParams = new URLSearchParams(window.location.search);
      input.value = (nextParams.get('q') || '').slice(0, 160);
      category = filters.some((button) => button.dataset.category === nextParams.get('category')) ? (nextParams.get('category') || '') : '';
      currentPage = Math.max(1, Number.parseInt(nextParams.get('page') || '1', 10) || 1);
      requestedFocus = true;
      render({ updateHistory: false });
    });
    render({ updateHistory: false });
  };

  document.querySelectorAll('[data-knowledge]').forEach((root) => {
    try { initialize(root); }
    catch (_) {
      const grid = root.querySelector('[data-knowledge-results]');
      const status = root.querySelector('[data-knowledge-status]');
      const failure = root.querySelector('[data-knowledge-error]');
      if (grid) { grid.hidden = true; grid.setAttribute('aria-busy', 'false'); }
      if (failure) failure.hidden = false;
      if (status && failure) status.textContent = failure.querySelector('p').textContent;
    }
  });
})();